module.exports = __webpack_public_path__ + "assets/fonts/opensans-bold-webfont.woff2";